import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { AirportGateway } from 'src/app/application/gateway/AirportGateway';
import { CountryGateway } from 'src/app/application/gateway/CountryGateway';
import { DeliveryDiscountGateway } from 'src/app/application/gateway/DeliveryDiscountGateway';
import { DeliveryGateway } from 'src/app/application/gateway/DeliveryGateway';
import { ExportOfferGateway } from 'src/app/application/gateway/ExportOfferGateway';
import { FrozenFruitExportOfferGateway } from 'src/app/application/gateway/FrozenFruitExportOfferGateway';
import { PortGateway } from 'src/app/application/gateway/PortGateway';
import { Airport } from 'src/app/domain/models/Airport';
import { Country } from 'src/app/domain/models/Country';
import { Delivery, DeliveryInformation, UpdateDeliveryRequest } from 'src/app/domain/models/Delivery';
import { DeliveryDiscount, NewDeliveryDiscount } from 'src/app/domain/models/DeliveryDiscount';
import { ExportOffer } from 'src/app/domain/models/ExportOffer';
import { FrozenFruitExportOffer } from 'src/app/domain/models/FrozenFruitExportOffer';
import { GenericOrderDetail, ImportOrderDetail, ImportOrderInformation } from 'src/app/domain/models/ImportOrder';
import { Packaging } from 'src/app/domain/models/Packaging';
import { Port } from 'src/app/domain/models/Port';
import { ProductCertificateType } from 'src/app/domain/models/ProductCertificateType';
import { Importer } from 'src/app/domain/models/Profile';
import { Routes } from 'src/app/infrastructure/routes';
import { ErrorMessageUtil } from 'src/app/ui/util/error-message-util';
import readXlsxFile, { readSheetNames } from 'read-excel-file';
import { ImportOrderGateway } from 'src/app/application/gateway/ImportOrderGateway';
import { DeliveryCost } from 'src/app/domain/models/DeliveryCost';
import { DeliveryCostGateway } from 'src/app/application/gateway/DeliveryCostGateway';
import { LocationType } from 'src/app/domain/enums/location-type.enum';
import { CityService } from 'src/app/application/service/CityService';
import { City } from 'src/app/domain/models/City';
import { CurrencyGateway } from 'src/app/application/gateway/CurrencyGateway';
import { Currency } from 'src/app/domain/models/currency';

interface DiscountModel {
  originDiscounts: DeliveryDiscount[]
  destinationDiscounts: DeliveryDiscount[]
}

interface CostModel {
  originCosts: DeliveryCost[]
  destinationCosts: DeliveryCost[]
}

@Component({
  selector: 'app-admin-delivery',
  templateUrl: './admin-delivery.component.html',
  styleUrls: ['./admin-delivery.component.css'],

})
export class AdminDeliveryComponent implements OnInit {

  orderId: any | undefined
  deliveryInformation: DeliveryInformation | undefined
  delivery: Delivery | undefined
  importer: Importer | undefined
  discounts: DiscountModel = {
    originDiscounts: [],
    destinationDiscounts: []
  }
  costs: CostModel = {
    originCosts: [],
    destinationCosts: []
  }
  locationTypeEnum = LocationType
  locationType: string = LocationType.Origen
  orderDetails: GenericOrderDetail[] = []
  selectedExportOffer: ExportOffer | undefined
  selectedProductCertificateTypes: ProductCertificateType[] = []
  selectedPackagingTypes: Packaging[] = []
  frozenFruitExportOffer: FrozenFruitExportOffer | undefined
  ports: Port[] = []
  cities: City[] = []
  countries: Country[] = []

  order: ImportOrderInformation | undefined

  loading: boolean = false
  submit: boolean = false
  visibleOfferDetailDialog: boolean = false
  discountDialogVisible: boolean = false
  submitDiscount: boolean = false
  isCloseSale: boolean = false
  selectedCost: DeliveryCost | undefined
  submitCost = false
  costDialogVisible = false
  currencies: string[] = []

  IsfFormMode: boolean = false;

  formGroup: FormGroup = this._formBuilder.group({
    bl: [''],
    booking: [''],
    containerNumber: [''],
    deliveryInstructions: [''],
    grossWeight: [''],
    containerCbm: [''],
    containerTemperature: [''],
    placeReceipt: [''],
    departurePortId: [''],
    destinationPortId: [''],
    placeDelivery: [''],
    ship: [''],
    voyageNumber: [''],
    typeMovement: [''],
    oceanFreight: [null],
    inland: [null],
    localCharges: [null],
    customs: [null],
    otherCosts: [null],
    freightPayableAt: [''],
    shippedOnBoard: [null],
    placeIssue: [''],
    dateIssue: [null],
    excessValueDeclaration: [''],
    notifierContactName: [''],
    notifierContactEmail: [''],
    notifierContactCity: [''],
    notifierContactAddress: [''],
    notifierCompanyName: [''],
    notifierContactPhone: [''],
    notifierVAT: [''],
    notifierContactCountryId: [''],
    consigneeContactName: [''],
    consigneeContactEmail: [''],
    consigneeContactPhone: [''],
    consigneeContactAddress: [''],
    consigneeContactCity: [''],
    consigneeCompanyName: [''],
    consigneeVAT: [''],
    consigneeContactCountryId: [''],
    week: [null],
    surcharge: [null],
    etd: [null],
    eta: [null],
    handling: [null],
    gateOut: [null],
    atmControl: [null],
    co2Reduction: [null],
    lowSulfurSurcharge: [null],
    advancedManifestDeclaration: [null],
    bunkerAdjustmentFactor: [null],
    stackingStart: [null],
    stackingEnd: [null],
    dus: [''],
    sps: [''],
    cutoffDate: [null],
    carrierName: [''],
    departurePatentTruck: [''],
    departurePatentCar: [''],
    mbl: [''],
    ot: [''],
    ref1: [''],
    ref2: [''],
    ctr: [''],
    importPurchaseOrder: [''],
    seal: [''],
    departureAirportId: ['', Validators.required],
    destinationAirportId: ['', Validators.required],
    truckDriverName: [''],
    containerDeposit: [''],
    shippingCompanyName: [''],
    inputRepalletizationCode: [''],
    inputRepalletizationDate: [null],
    inputToProcessCode: [''],
    inputToProcessDate: [null],
    dispatchCode: [''],
    dispatchDate: [null],
    dispatchType: [''],
    inspectionEntity: [''],
    dispatchInspectionType: [''],
    exporterInstructive: [''],
    driverName: [''],
    vehiclePlate: [''],
    wagonPlate: [''],
    customsCode: [''],
    customsName: [''],
    codeShippingAgency: [''],
    nameShippingAgency: [''],
    forwarderCode: [''],
    forwarderName: [''],
    shipperCode: [''],
    shipperName: [''],
    exporterCode: [''],
    exporterName: [''],
    destinationPlantCode: [''],
    hatch: [''],
    receiverCode: [''],
    receiverName: [''],
    consigneeCode: [''],
    vesselCode: [''],
    transportTypeCode: [''],
    vesselType: [''],
    departurePortCode: [''],
    departurePortName: [''],
    departureCountry: [''],
    departureWeek: [''],
    arrivalPortCode: [''],
    arrivalPort: [''],
    arrivalCountry: [''],
    arrivalContinent: [''],
    isfCases: [0],
    isfPallets: [0]
  })

  visible: boolean = false
  excelFile: any
  excelSheets: any
  startRow: number = 1
  selectedSheet: string = ''

  discountFormGroup: FormGroup = this._formBuilder.group({
    description: ['', Validators.required],
    amount: [null, Validators.required],
    currencyCode: ['', Validators.required]
  })

  costFormGroup: FormGroup = this._formBuilder.group({
    description: ['', Validators.required],
    amount: [null, Validators.required],
    currencyCode: ['', Validators.required]
  })

  airPorts: Airport[] = []

  constructor(private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _formBuilder: FormBuilder,
    private _messageService: MessageService,
    private _portService: PortGateway,
    private _countryService: CountryGateway,
    private _deliveryService: DeliveryGateway,
    public translate: TranslateService,
    private _deliveryDiscountService: DeliveryDiscountGateway,
    private _deliveryCostService: DeliveryCostGateway,
    private _exportOfferService: ExportOfferGateway,
    private _frozenFruitExportOfferService: FrozenFruitExportOfferGateway,
    private _airportService: AirportGateway,
    private _importOrderService: ImportOrderGateway,
    private _cityService: CityService,
    private _currencyService: CurrencyGateway
  ) {
    this._activatedRoute.params.subscribe(params => {
      this.orderId = params['orderId']
    })
  }

  ngOnInit(): void {
    this.loadDelivery()
    this.loadImportOrder()
    this.getCurrencies()
  }

  loadDelivery() {
    if(this.orderId) {
      this.loading = true
      this._deliveryService.getByImportOrderId(this.orderId).subscribe({
        next: (v) => {
          this.deliveryInformation = v
          this.delivery = this.deliveryInformation.delivery
          this.importer = this.deliveryInformation.importer
          this.orderDetails = this.deliveryInformation.orderDetails
          this.discounts.originDiscounts = this.getLocationTypeDiscounts(LocationType.Origen, this.deliveryInformation.discounts)
          this.discounts.destinationDiscounts = this.getLocationTypeDiscounts(LocationType.Destino, this.deliveryInformation.discounts)
          this.costs.originCosts = this.getLocationTypeCosts(LocationType.Origen, this.deliveryInformation.costs)
          this.costs.destinationCosts = this.getLocationTypeCosts(LocationType.Destino, this.deliveryInformation.costs)
          this.isCloseSale = this.deliveryInformation.isCloseSale

          this.formGroup.controls['importPurchaseOrder'].setValue(this.deliveryInformation.importPurchaseOrder)
          this.loadForm()
        },
        error: (e) => {
          let errorMessage = ''
            const lang = this.translate.currentLang
            switch(lang) {
              case 'es':
                errorMessage = e.error.messageEs
                break
              case 'en':
                errorMessage = e.error.messageEn
                break
              default:
                errorMessage = this.translate.instant('MessageService.Delivery.SingleRetrieveError')
          }
          this._messageService.add({
            severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: errorMessage
          });
        },
        complete: () => {
          this.loading = false
        }
      })
    }
  }

  getLocationTypeDiscounts(locationType: string, data: DeliveryDiscount[]) {
    return data.filter((el) => el.locationType === locationType)
  }

  getLocationTypeCosts(locationType: string, data: DeliveryCost[]) {
    return data.filter((el) => el.locationType === locationType)
  }

  loadImportOrder()
  {
    if(this.orderId)
    {
      this.loading = true
      this._importOrderService.getById(this.orderId).subscribe(
        {
          next: (v) => {
            this.order = v;
            this.loading = false
          },
          error: () => {
          this.loading = false
          this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: 'Failed retrieving sale program'});
        }
        }
      )

    }
  }

    showDialog() {
      this.excelFile = null
      this.excelSheets = null
      this.startRow = 1
      this.visible = true
    }

    onSelectExcelFile(uploader: any) {
      this.excelFile = uploader.files[0]
      readSheetNames(uploader.files[0]).catch( error => {
        this._messageService.add({
          severity: 'error',
          summary: this.translate.instant('MessageService.Excel.FailedAction'),
          detail: this.translate.instant('UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.FormatExcelMessage')
        })

        this.loading = false

      }).then((sheetNames) => {
        this.excelSheets = sheetNames
      })

      uploader.clear()
    }

  loadPorts() {
    this._portService.getAll().subscribe({
      next: (v) => {
        this.ports = v
        // this.ports = this.ports.map((item) => {
        //   return {
        //     ...item,
        //     fullname: `${item.name} ${item?.locode ? "(" + item.locode + ")" : ""}`
        //   }
        // })
      },
      error: (e) => {
        this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudieron recuperar los puertos.' });
      },
      complete: () => {
        this.loading = false
      }
    })
  }

  loadAirports()
  {
    this.loading = true
    this._airportService.getAll().subscribe({
      next: (v) => {
        this.airPorts = v
        this.loading = false
      },
      error: (e) => {
        this.loading = false
        this._messageService.add({
          severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.Airport.ManyRetrieveError')
        });
      }
    })
  }

  loadCities() {
    this.loading = true
    this._cityService.getAll().subscribe({
      next: (v) => {
        this.cities = v;
        this.loading = false
      },
      error: (e) => {
        this.loading = false
        this._messageService.add({
          severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.City.ManyRetrieveError')
        });
      }
    })
  }

  loadCountries() {
    this._countryService.getAll().subscribe({
      next: (v) => {
        this.countries = v
      },
      error: (e) => {
        this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudieron recuperar los puertos.' });
      },
      complete: () => {
        this.loading = false
      }
    })
  }

  validateForm(){
    if(this.delivery){
      if(this.delivery.transportType === 0){
        this.formGroup.controls['destinationPortId'].setValidators([Validators.required]);
        this.formGroup.controls['departurePortId'].setValidators([Validators.required]);
        this.formGroup.controls['departureAirportId'].clearValidators();
        this.formGroup.controls['destinationAirportId'].clearValidators();
      } else {
        this.formGroup.controls['departureAirportId'].setValidators([Validators.required]);
        this.formGroup.controls['destinationAirportId'].setValidators([Validators.required]);
        this.formGroup.controls['departurePortId'].clearValidators();
        this.formGroup.controls['destinationPortId'].clearValidators();
      }
      this.formGroup.controls['departureAirportId'].updateValueAndValidity()
      this.formGroup.controls['destinationAirportId'].updateValueAndValidity();
      this.formGroup.controls['departurePortId'].updateValueAndValidity();
      this.formGroup.controls['destinationPortId'].updateValueAndValidity();
    }
  }

  loadForm() {
    if(this.delivery) {
      this.loadCountries()
      switch(this.delivery.transportType)
      {
        case 0:
          this.loadPorts();
          break;
        case 1:
          this.loadAirports();
          break;
        default:
          this.loadCities();
      }



      this.formGroup.controls['bl'].setValue(this.delivery.bl)
      this.formGroup.controls['booking'].setValue(this.delivery.booking)
      this.formGroup.controls['containerNumber'].setValue(this.delivery.containerNumber)
      this.formGroup.controls['deliveryInstructions'].setValue(this.delivery.deliveryInstructions)
      this.formGroup.controls['grossWeight'].setValue(this.delivery.grossWeight)
      this.formGroup.controls['containerCbm'].setValue(this.delivery.containerCbm)
      this.formGroup.controls['containerTemperature'].setValue(this.delivery.containerTemperature)
      this.formGroup.controls['placeReceipt'].setValue(this.delivery.placeReceipt)
      this.formGroup.controls['departurePortId'].setValue(this.delivery.departurePortId)
      this.formGroup.controls['destinationPortId'].setValue(this.delivery.destinationPortId)
      this.formGroup.controls['placeDelivery'].setValue(this.delivery.placeDelivery)
      this.formGroup.controls['ship'].setValue(this.delivery.ship)
      this.formGroup.controls['voyageNumber'].setValue(this.delivery.voyageNumber)
      this.formGroup.controls['typeMovement'].setValue(this.delivery.typeMovement)
      this.formGroup.controls['oceanFreight'].setValue(this.delivery.oceanFreight)
      this.formGroup.controls['inland'].setValue(this.delivery.inland)
      this.formGroup.controls['localCharges'].setValue(this.delivery.localCharges)
      this.formGroup.controls['customs'].setValue(this.delivery.customs)
      this.formGroup.controls['otherCosts'].setValue(this.delivery.otherCosts)
      this.formGroup.controls['freightPayableAt'].setValue(this.delivery.freightPayableAt)
      this.formGroup.controls['shippedOnBoard'].setValue(this.delivery.shippedOnBoard ? new Date(this.delivery.shippedOnBoard) : null)
      this.formGroup.controls['placeIssue'].setValue(this.delivery.placeIssue)
      this.formGroup.controls['dateIssue'].setValue(this.delivery.dateIssue ? new Date(this.delivery.dateIssue) : null)
      this.formGroup.controls['excessValueDeclaration'].setValue(this.delivery.excessValueDeclaration)
      this.formGroup.controls['notifierContactName'].setValue(this.delivery.notifierContactName)
      this.formGroup.controls['notifierContactEmail'].setValue(this.delivery.notifierContactEmail)
      this.formGroup.controls['notifierContactCity'].setValue(this.delivery.notifierContactCity)
      this.formGroup.controls['notifierContactAddress'].setValue(this.delivery.notifierContactAddress)
      this.formGroup.controls['notifierCompanyName'].setValue(this.delivery.notifierCompanyName)
      this.formGroup.controls['notifierContactPhone'].setValue(this.delivery.notifierContactPhone)
      this.formGroup.controls['notifierVAT'].setValue(this.delivery.notifierVAT)
      this.formGroup.controls['notifierContactCountryId'].setValue(this.delivery.notifierContactCountryId)
      this.formGroup.controls['consigneeContactName'].setValue(this.delivery.consigneeContactName)
      this.formGroup.controls['consigneeContactEmail'].setValue(this.delivery.consigneeContactEmail)
      this.formGroup.controls['consigneeContactPhone'].setValue(this.delivery.consigneeContactPhone)
      this.formGroup.controls['consigneeContactAddress'].setValue(this.delivery.consigneeContactAddress)
      this.formGroup.controls['consigneeContactCity'].setValue(this.delivery.consigneeContactCity)
      this.formGroup.controls['consigneeCompanyName'].setValue(this.delivery.consigneeCompanyName)
      this.formGroup.controls['consigneeVAT'].setValue(this.delivery.consigneeVAT)
      this.formGroup.controls['consigneeContactCountryId'].setValue(this.delivery.consigneeContactCountryId)
      this.formGroup.controls['week'].setValue(this.delivery.week)
      this.formGroup.controls['surcharge'].setValue(this.delivery.surcharge)
      this.formGroup.controls['etd'].setValue(this.delivery.etd ? new Date(this.delivery.etd) : null)
      this.formGroup.controls['eta'].setValue(this.delivery.eta ? new Date(this.delivery.eta) : null)
      this.formGroup.controls['handling'].setValue(this.delivery.handling)
      this.formGroup.controls['gateOut'].setValue(this.delivery.gateOut)

      // Nuevos costos estáticos
      this.formGroup.controls['atmControl'].setValue(this.delivery.atmControl)
      this.formGroup.controls['co2Reduction'].setValue(this.delivery.co2Reduction)
      this.formGroup.controls['lowSulfurSurcharge'].setValue(this.delivery.lowSulfurSurcharge)
      this.formGroup.controls['advancedManifestDeclaration'].setValue(this.delivery.advancedManifestDeclaration)
      this.formGroup.controls['bunkerAdjustmentFactor'].setValue(this.delivery.bunkerAdjustmentFactor)

      this.formGroup.controls['stackingStart'].setValue(this.delivery.stackingStart ? new Date(this.delivery.stackingStart) : null)
      this.formGroup.controls['stackingEnd'].setValue(this.delivery.stackingEnd ? new Date(this.delivery.stackingEnd) : null)
      this.formGroup.controls['dus'].setValue(this.delivery.dus)
      this.formGroup.controls['sps'].setValue(this.delivery.sps)
      this.formGroup.controls['cutoffDate'].setValue(this.delivery.cutoffDate ? new Date(this.delivery.cutoffDate) : null)
      this.formGroup.controls['carrierName'].setValue(this.delivery.carrierName)
      this.formGroup.controls['departurePatentTruck'].setValue(this.delivery.departurePatentTruck)
      this.formGroup.controls['departurePatentCar'].setValue(this.delivery.departurePatentCar)
      this.formGroup.controls['mbl'].setValue(this.delivery.mbl)
      this.formGroup.controls['ot'].setValue(this.delivery.ot)
      this.formGroup.controls['ref1'].setValue(this.delivery.ref1)
      this.formGroup.controls['ref2'].setValue(this.delivery.ref2)
      this.formGroup.controls['ctr'].setValue(this.delivery.ctr)
      this.formGroup.controls['seal'].setValue(this.delivery.seal)
      this.formGroup.controls['departureAirportId'].setValue(this.delivery.departureAirportId)
      this.formGroup.controls['destinationAirportId'].setValue(this.delivery.destinationAirportId)
      this.formGroup.controls['truckDriverName'].setValue(this.delivery.truckDriverName)
      this.formGroup.controls['containerDeposit'].setValue(this.delivery.containerDeposit)
      this.formGroup.controls['shippingCompanyName'].setValue(this.delivery.shippingCompanyName)

      this.formGroup.controls['inputRepalletizationCode'].setValue(this.delivery.inputRepalletizationCode);
      this.formGroup.controls['inputRepalletizationDate'].setValue(this.delivery.inputRepalletizationDate ? new Date(this.delivery.inputRepalletizationDate) : null);
      this.formGroup.controls['inputToProcessCode'].setValue(this.delivery.inputToProcessCode);
      this.formGroup.controls['inputToProcessDate'].setValue(this.delivery.inputToProcessDate ? new Date(this.delivery.inputToProcessDate) : null);
      this.formGroup.controls['dispatchCode'].setValue(this.delivery.dispatchCode);
      this.formGroup.controls['dispatchDate'].setValue(this.delivery.dispatchDate ? new Date(this.delivery.dispatchDate) : null);
      this.formGroup.controls['dispatchType'].setValue(this.delivery.dispatchType);
      this.formGroup.controls['inspectionEntity'].setValue(this.delivery.inspectionEntity);
      this.formGroup.controls['dispatchInspectionType'].setValue(this.delivery.dispatchInspectionType);
      this.formGroup.controls['exporterInstructive'].setValue(this.delivery.exporterInstructive);
      this.formGroup.controls['driverName'].setValue(this.delivery.driverName);
      this.formGroup.controls['vehiclePlate'].setValue(this.delivery.vehiclePlate);
      this.formGroup.controls['wagonPlate'].setValue(this.delivery.wagonPlate);
      this.formGroup.controls['customsCode'].setValue(this.delivery.customsCode);
      this.formGroup.controls['customsName'].setValue(this.delivery.customsName);
      this.formGroup.controls['codeShippingAgency'].setValue(this.delivery.codeShippingAgency);
      this.formGroup.controls['nameShippingAgency'].setValue(this.delivery.nameShippingAgency);
      this.formGroup.controls['forwarderCode'].setValue(this.delivery.forwarderCode);
      this.formGroup.controls['forwarderName'].setValue(this.delivery.forwarderName);
      this.formGroup.controls['shipperCode'].setValue(this.delivery.shipperCode);
      this.formGroup.controls['shipperName'].setValue(this.delivery.shipperName);
      this.formGroup.controls['exporterCode'].setValue(this.delivery.exporterCode);
      this.formGroup.controls['exporterName'].setValue(this.delivery.exporterName);
      this.formGroup.controls['destinationPlantCode'].setValue(this.delivery.destinationPlantCode);
      this.formGroup.controls['hatch'].setValue(this.delivery.hatch);
      this.formGroup.controls['receiverCode'].setValue(this.delivery.receiverCode);
      this.formGroup.controls['receiverName'].setValue(this.delivery.receiverName);
      this.formGroup.controls['consigneeCode'].setValue(this.delivery.consigneeCode);
      this.formGroup.controls['vesselCode'].setValue(this.delivery.vesselCode);
      this.formGroup.controls['transportTypeCode'].setValue(this.delivery.transportTypeCode);
      this.formGroup.controls['vesselType'].setValue(this.delivery.vesselType);
      this.formGroup.controls['departurePortCode'].setValue(this.delivery.departurePortCode);
      this.formGroup.controls['departurePortName'].setValue(this.delivery.departurePortName);
      this.formGroup.controls['departureCountry'].setValue(this.delivery.departureCountry);
      this.formGroup.controls['departureWeek'].setValue(this.delivery.departureWeek);
      this.formGroup.controls['arrivalPortCode'].setValue(this.delivery.arrivalPortCode);
      this.formGroup.controls['arrivalPort'].setValue(this.delivery.arrivalPort);
      this.formGroup.controls['arrivalCountry'].setValue(this.delivery.arrivalCountry);
      this.formGroup.controls['arrivalContinent'].setValue(this.delivery.arrivalContinent);

      this.formGroup.controls['isfPallets'].setValue(this.delivery.isfPallets);
      this.formGroup.controls['isfCases'].setValue(this.delivery.isfCases);
      this.validateForm()
    }
  }

  getDetailTotalPrice(detail: GenericOrderDetail): number {
    if(detail.palletsQuantity > 0 && detail.boxesPerPallet > 0) {
      return detail.palletsQuantity * detail.boxesPerPallet * detail.price
    }
    else {
      return detail.boxesQuantity * detail.price
    }
  }

  getDetailPalletPrice(detail: GenericOrderDetail): number {
    let total = 0

    if(detail.palletPrices)
    {
      detail.palletPrices.forEach(x => {
        total += x.price ? x.boxPerPallets * x.price : 0;
      })
      return total
    }
    return 0
  }

  getDetailTotalCases(detail: GenericOrderDetail): number {
    return detail.palletsQuantity > 0 && detail.boxesPerPallet > 0 ? detail.palletsQuantity * detail.boxesPerPallet : detail.boxesQuantity
  }

  openExportOfferDialog(detail: GenericOrderDetail) {

    this.selectedExportOffer = undefined
    this.frozenFruitExportOffer = undefined

    if(this.deliveryInformation && this.deliveryInformation.isFrozenFruit) {
      this.loading = true
      this._frozenFruitExportOfferService.getById(detail.frozenFruitExportOfferId!).subscribe({
        next: (v) => {
          this.frozenFruitExportOffer = v
          this.loading = false
          this.visibleOfferDetailDialog = true
        },
        error: (e) => {
          this.loading = false
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.ExportOffer.SingleRetrieveError') })
        }
      })
    }
    else {
      this.loading = true
      this._exportOfferService.getById(detail.exportOfferId!).subscribe({
        next: (v) => {
          this.selectedExportOffer = v
          if(this.selectedExportOffer.productCertificateTypes)
            this.selectedProductCertificateTypes = this.selectedExportOffer.productCertificateTypes

          if(this.selectedExportOffer.packagingTypes)
            this.selectedPackagingTypes = this.selectedExportOffer.packagingTypes

          this.loading = false
          this.visibleOfferDetailDialog = true
        },
        error: (e) => {
          this.loading = false
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.ExportOffer.SingleRetrieveError') })
        }
      })
    }
  }


  save() {
    this.submit = true
    this.loading = true
    if(this.formGroup.valid) {
      if(this.delivery && this.orderId) {
        this.delivery.bl = this.formGroup.controls['bl'].value
        this.delivery.booking = this.formGroup.controls['booking'].value
        this.delivery.deliveryInstructions = this.formGroup.controls['deliveryInstructions'].value
        this.delivery.grossWeight = this.formGroup.controls['grossWeight'].value
        this.delivery.containerCbm = this.formGroup.controls['containerCbm'].value
        this.delivery.containerTemperature = this.formGroup.controls['containerTemperature'].value
        this.delivery.placeReceipt = this.formGroup.controls['placeReceipt'].value
        this.delivery.departurePortId = this.formGroup.controls['departurePortId'].value
        this.delivery.destinationPortId = this.formGroup.controls['destinationPortId'].value
        this.delivery.placeDelivery = this.formGroup.controls['placeDelivery'].value
        this.delivery.ship = this.formGroup.controls['ship'].value
        this.delivery.voyageNumber = this.formGroup.controls['voyageNumber'].value
        this.delivery.typeMovement = this.formGroup.controls['typeMovement'].value
        this.delivery.oceanFreight = this.formGroup.controls['oceanFreight'].value ?? 0
        this.delivery.inland = this.formGroup.controls['inland'].value ?? 0
        this.delivery.localCharges = this.formGroup.controls['localCharges'].value ?? 0
        this.delivery.customs = this.formGroup.controls['customs'].value ?? 0
        this.delivery.otherCosts = this.formGroup.controls['otherCosts'].value ?? 0
        this.delivery.freightPayableAt = this.formGroup.controls['freightPayableAt'].value
        this.delivery.shippedOnBoard = this.formGroup.controls['shippedOnBoard'].value
        this.delivery.placeIssue = this.formGroup.controls['placeIssue'].value
        this.delivery.dateIssue = this.formGroup.controls['dateIssue'].value
        this.delivery.excessValueDeclaration = this.formGroup.controls['excessValueDeclaration'].value
        this.delivery.notifierContactName = this.formGroup.controls['notifierContactName'].value
        this.delivery.notifierContactEmail = this.formGroup.controls['notifierContactEmail'].value
        this.delivery.notifierContactCity = this.formGroup.controls['notifierContactCity'].value
        this.delivery.notifierContactAddress = this.formGroup.controls['notifierContactAddress'].value
        this.delivery.notifierCompanyName = this.formGroup.controls['notifierCompanyName'].value
        this.delivery.notifierContactPhone = this.formGroup.controls['notifierContactPhone'].value
        this.delivery.notifierVAT = this.formGroup.controls['notifierVAT'].value
        this.delivery.notifierContactCountryId = this.formGroup.controls['notifierContactCountryId'].value
        this.delivery.consigneeContactName = this.formGroup.controls['consigneeContactName'].value
        this.delivery.consigneeContactEmail = this.formGroup.controls['consigneeContactEmail'].value
        this.delivery.consigneeContactPhone = this.formGroup.controls['consigneeContactPhone'].value
        this.delivery.consigneeContactAddress = this.formGroup.controls['consigneeContactAddress'].value
        this.delivery.consigneeContactCity = this.formGroup.controls['consigneeContactCity'].value
        this.delivery.consigneeCompanyName = this.formGroup.controls['consigneeCompanyName'].value
        this.delivery.consigneeVAT = this.formGroup.controls['consigneeVAT'].value
        this.delivery.consigneeContactCountryId = this.formGroup.controls['consigneeContactCountryId'].value
        this.delivery.containerNumber = this.formGroup.controls['containerNumber'].value
        this.delivery.week = this.formGroup.controls['week'].value
        this.delivery.surcharge = this.formGroup.controls['surcharge'].value ?? 0
        this.delivery.etd = this.formGroup.controls['etd'].value
        this.delivery.eta = this.formGroup.controls['eta'].value
        this.delivery.handling = this.formGroup.controls['handling'].value ?? 0
        this.delivery.gateOut = this.formGroup.controls['gateOut'].value ?? 0

        this.delivery.atmControl = this.formGroup.controls['atmControl'].value ?? 0
        this.delivery.co2Reduction = this.formGroup.controls['co2Reduction'].value ?? 0
        this.delivery.lowSulfurSurcharge = this.formGroup.controls['lowSulfurSurcharge'].value ?? 0
        this.delivery.advancedManifestDeclaration = this.formGroup.controls['advancedManifestDeclaration'].value ?? 0
        this.delivery.bunkerAdjustmentFactor = this.formGroup.controls['bunkerAdjustmentFactor'].value ?? 0

        this.delivery.dus = this.formGroup.controls['dus'].value
        this.delivery.sps = this.formGroup.controls['sps'].value
        this.delivery.truckDriverName = this.formGroup.controls['truckDriverName'].value
        this.delivery.shippingCompanyName = this.formGroup.controls['shippingCompanyName'].value
        this.delivery.containerDeposit = this.formGroup.controls['containerDeposit'].value

        let selectedStackingStartDateTime = this.formGroup.controls['stackingStart'].value
        if (selectedStackingStartDateTime) this.delivery.stackingStart = new Date(selectedStackingStartDateTime.getTime() - (selectedStackingStartDateTime.getTimezoneOffset() * 60000))

          let selectedStackingEndDateTime = this.formGroup.controls['stackingEnd'].value
          if (selectedStackingEndDateTime) this.delivery.stackingEnd = new Date(selectedStackingEndDateTime.getTime() - (selectedStackingEndDateTime.getTimezoneOffset() * 60000))

            let selectedCutoffDateTime = this.formGroup.controls['cutoffDate'].value
            if (selectedCutoffDateTime) this.delivery.cutoffDate = new Date(selectedCutoffDateTime.getTime() - (selectedCutoffDateTime.getTimezoneOffset() * 60000))

        // this.delivery.cutoffDate = this.formGroup.controls['cutoffDate'].value
        this.delivery.carrierName = this.formGroup.controls['carrierName'].value
        this.delivery.departurePatentTruck = this.formGroup.controls['departurePatentTruck'].value
        this.delivery.departurePatentCar = this.formGroup.controls['departurePatentCar'].value
        this.delivery.mbl = this.formGroup.controls['mbl'].value
        this.delivery.ot = this.formGroup.controls['ot'].value
        this.delivery.ref1 = this.formGroup.controls['ref1'].value
        this.delivery.ref2 = this.formGroup.controls['ref2'].value
        this.delivery.ctr = this.formGroup.controls['ctr'].value
        this.delivery.seal = this.formGroup.controls['seal'].value

        this.delivery.departureAirportId = this.formGroup.controls['departureAirportId'].value;
        this.delivery.destinationAirportId = this.formGroup.controls['destinationAirportId'].value;

      this.delivery.inputRepalletizationCode = this.formGroup.controls['inputRepalletizationCode'].value;
      this.delivery.inputRepalletizationDate = this.formGroup.controls['inputRepalletizationDate'].value;
      this.delivery.inputToProcessCode = this.formGroup.controls['inputToProcessCode'].value;
      this.delivery.inputToProcessDate = this.formGroup.controls['inputToProcessDate'].value;
      this.delivery.dispatchCode = this.formGroup.controls['dispatchCode'].value;

      let selectedDispatchDateTime = this.formGroup.controls['dispatchDate'].value;
      if (selectedDispatchDateTime) this.delivery.dispatchDate = new Date(selectedDispatchDateTime.getTime() - (selectedDispatchDateTime.getTimezoneOffset() * 60000))

      this.delivery.dispatchDate = this.formGroup.controls['dispatchDate'].value;
      this.delivery.dispatchType = this.formGroup.controls['dispatchType'].value;
      this.delivery.inspectionEntity = this.formGroup.controls['inspectionEntity'].value;
      this.delivery.dispatchInspectionType = this.formGroup.controls['dispatchInspectionType'].value;
      this.delivery.exporterInstructive = this.formGroup.controls['exporterInstructive'].value;
      this.delivery.driverName = this.formGroup.controls['driverName'].value;
      this.delivery.vehiclePlate = this.formGroup.controls['vehiclePlate'].value;
      this.delivery.wagonPlate = this.formGroup.controls['wagonPlate'].value;
      this.delivery.customsCode = this.formGroup.controls['customsCode'].value;
      this.delivery.customsName = this.formGroup.controls['customsName'].value;
      this.delivery.codeShippingAgency = this.formGroup.controls['codeShippingAgency'].value;
      this.delivery.nameShippingAgency = this.formGroup.controls['nameShippingAgency'].value;
      this.delivery.forwarderCode = this.formGroup.controls['forwarderCode'].value;
      this.delivery.forwarderName = this.formGroup.controls['forwarderName'].value;
      this.delivery.shipperCode = this.formGroup.controls['shipperCode'].value;
      this.delivery.shipperName = this.formGroup.controls['shipperName'].value;
      this.delivery.exporterCode = this.formGroup.controls['exporterCode'].value;
      this.delivery.exporterName = this.formGroup.controls['exporterName'].value;
      this.delivery.destinationPlantCode = this.formGroup.controls['destinationPlantCode'].value;
      this.delivery.hatch = this.formGroup.controls['hatch'].value;
      this.delivery.receiverCode = this.formGroup.controls['receiverCode'].value;
      this.delivery.receiverName = this.formGroup.controls['receiverName'].value;
      this.delivery.consigneeCode = this.formGroup.controls['consigneeCode'].value;
      this.delivery.vesselCode = this.formGroup.controls['vesselCode'].value;
      this.delivery.transportTypeCode = this.formGroup.controls['transportTypeCode'].value;
      this.delivery.vesselType = this.formGroup.controls['vesselType'].value;
      this.delivery.departurePortCode = this.formGroup.controls['departurePortCode'].value;
      this.delivery.departurePortName = this.formGroup.controls['departurePortName'].value;
      this.delivery.departureCountry = this.formGroup.controls['departureCountry'].value;
      this.delivery.departureWeek = this.formGroup.controls['departureWeek'].value;
      this.delivery.arrivalPortCode = this.formGroup.controls['arrivalPortCode'].value;
      this.delivery.arrivalPort = this.formGroup.controls['arrivalPort'].value;
      this.delivery.arrivalCountry = this.formGroup.controls['arrivalCountry'].value;
      this.delivery.arrivalContinent = this.formGroup.controls['arrivalContinent'].value;

      this.delivery.isfCases = this.formGroup.controls['isfCases'].value;
      this.delivery.isfPallets = this.formGroup.controls['isfPallets'].value;

        const request: UpdateDeliveryRequest = {
          importOrderId: this.orderId,
          delivery: this.delivery,
          importPurchaseOrder: this.formGroup.controls['importPurchaseOrder'].value ?? ''
        }

        this._deliveryService.update(request).subscribe({
          next: (v) => {
            this.deliveryInformation = v
            this.loading = false
            this._messageService.add({ severity: 'success', summary: 'Acción exitosa', detail: 'El delivery fue actualizado con éxito.' })
          },
          error: (e) => {
            this.loading = false
            this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudo actualizar el delivey. Inténtelo de nuevo.' });
          },
          complete: () =>  {
            this.loading = false
            this.submit = false
          }
        })
      }
    }
    else {
      this.loading = false
      this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'Hay errores en el formulario.' });
    }
  }

  goToManageOrdersPage() {
    this._router.navigate(['/' + Routes.adminManageOrderPage])
  }

  goToOrderDetail() {
    this._router.navigate(['/' + Routes.adminOrderManagement, this.orderId])
  }

  getErrorMessage(formGroup: FormGroup, fieldName: string): string {
    return ErrorMessageUtil.getErrorMessage(formGroup, this.translate, fieldName)
  }

    onLoadExcel2()
    {
      this.loading = true
        if(!this.excelFile)
          return

        if(!this.selectedSheet)
          return

          readXlsxFile(this.excelFile, {sheet: this.selectedSheet}).catch( error => {
            this._messageService.add({
              severity: 'error',
              summary: this.translate.instant('MessageService.Excel.FailedAction'),
              detail: this.translate.instant('UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.FormatExcelMessage')
            })

            this.loading = false

          }).then((rows) => {
            if(rows) {
              this.formGroup.controls['mbl'].setValue(rows[0][1]?.toString());
              this.formGroup.controls['bl'].setValue(rows[1][1]?.toString());
              this.formGroup.controls['booking'].setValue(rows[2][1]?.toString());
              this.formGroup.controls['containerNumber'].setValue(rows[3][1].toString());
              this.formGroup.controls['deliveryInstructions'].setValue(rows[4][1].toString());

              const grossWeight = parseFloat(rows[5][1].toString());
              if(this.validateField(grossWeight, 'Gross Weight'))
              {
                this.formGroup.controls['grossWeight'].setValue(grossWeight);
              }


              const containerCbm = parseFloat(rows[6][1].toString());
              if(this.validateField(containerCbm, 'Ventilation CBM '))
              {
                this.formGroup.controls['containerCbm'].setValue(containerCbm);
              }


              const containerTemperature = parseFloat(rows[7][1].toString());
              if(this.validateField(containerTemperature, 'Ventilation Temperature'))
                {
                this.formGroup.controls['containerTemperature'].setValue(containerTemperature);
              }

              this.formGroup.controls['placeReceipt'].setValue(rows[8][1].toString());


              const week = parseInt(rows[9][1].toString());
              if(this.validateField(week, 'Week'))
              {
                this.formGroup.controls['week'].setValue(week);
              }

              this.formGroup.controls['placeDelivery'].setValue(rows[10][1].toString());
              this.formGroup.controls['ship'].setValue(rows[11][1].toString());
              this.formGroup.controls['voyageNumber'].setValue(rows[12][1].toString());
              this.formGroup.controls['typeMovement'].setValue(rows[13][1].toString());

              const etd = rows[14][1];
              this.formGroup.controls['etd'].setValue(new Date(etd.toString()));

              const eta = rows[15][1];
              this.formGroup.controls['eta'].setValue(new Date(eta.toString()));

              const stackingStart = rows[16][1];
              this.formGroup.controls['stackingStart'].setValue(new Date(stackingStart.toString()));

              const stackingEnd = rows[17][1];
              this.formGroup.controls['stackingEnd'].setValue(new Date(stackingEnd.toString()));


              this.formGroup.controls['dus'].setValue(rows[18][1].toString());
              this.formGroup.controls['sps'].setValue(rows[19][1].toString());

              const cutoffDate = rows[20][1].toString();
              this.formGroup.controls['cutoffDate'].setValue(new Date(cutoffDate.toString()));

              this.formGroup.controls['carrierName'].setValue(rows[21][1].toString());
              this.formGroup.controls['departurePatentTruck'].setValue(rows[22][1].toString());
              this.formGroup.controls['departurePatentCar'].setValue(rows[23][1].toString());
              this.formGroup.controls['ot'].setValue(rows[24][1].toString());
              this.formGroup.controls['ref1'].setValue(rows[25][1].toString());
              this.formGroup.controls['ref2'].setValue(rows[26][1].toString());
              this.formGroup.controls['ctr'].setValue(rows[27][1].toString());

              const oceanFreight = parseFloat(rows[28][1].toString());
              if(this.validateField(oceanFreight, 'Ocean Freight')){
                this.formGroup.controls['oceanFreight'].setValue(oceanFreight);
              }

              const inland = parseFloat(rows[29][1].toString())
              if(this.validateField(inland, 'Pick up'))
              {
                this.formGroup.controls['inland'].setValue(inland);
              }

              const localCharges = parseFloat(rows[30][1].toString());
              if(this.validateField(localCharges, 'Local Charges'))
              {
                this.formGroup.controls['localCharges'].setValue(localCharges);
              }

              const customs = parseFloat(rows[31][1].toString());

              if(this.validateField(customs, 'Custom agent'))
              {
                this.formGroup.controls['customs'].setValue(customs);
              }

              const surcharge = parseFloat(rows[32][1].toString());
              if(this.validateField(surcharge, 'Surcharge'))
              {
                this.formGroup.controls['surcharge'].setValue(surcharge);
              }

              const handling = parseFloat(rows[33][1].toString())
              if(this.validateField(handling, 'Handling'))
              {
                this.formGroup.controls['handling'].setValue(handling);
              }

              const gateOut = parseFloat(rows[34][1].toString());
              if(this.validateField(gateOut, 'Gate Out'))
              {
                this.formGroup.controls['gateOut'].setValue(gateOut);
              }

              const otherCosts = parseFloat(rows[35][1].toString());
              if(this.validateField(otherCosts, 'Others'))
              {
                this.formGroup.controls['otherCosts'].setValue(otherCosts);
              }

              this.formGroup.controls['freightPayableAt'].setValue(rows[36][1].toString());

              const shippedOnBoard = rows[37][1].toString();
              this.formGroup.controls['shippedOnBoard'].setValue(new Date (shippedOnBoard.toString()));

              this.formGroup.controls['placeIssue'].setValue(rows[38][1].toString());

              const dateIssue = rows[39][1];
              this.formGroup.controls['dateIssue'].setValue(new Date(dateIssue.toString()));

              this.formGroup.controls['excessValueDeclaration'].setValue(rows[40][1].toString());
              this.formGroup.controls['seal'].setValue(rows[41][1].toString());

              const departureLocode = rows[42][1].toString();
              const destinationLocode = rows[43][1].toString();

              if(this.delivery)
                {

                if(this.delivery.transportType === 0){
                  let departurePort = this.ports.find((x) => {
                    return x.locode === departureLocode
                  })
                  if(departurePort){
                    this.formGroup.controls['departurePortId'].setValue(departurePort.id);
                  }

                  let destinationPort = this.ports.find((x) => {
                    return x.locode === destinationLocode
                  })

                  if(destinationPort){
                    this.formGroup.controls['destinationPortId'].setValue(destinationPort.id);
                  }
                }else{
                  let departureAirport = this.airPorts.find((x) => {
                    return x.locode === departureLocode
                  })

                  if(departureAirport){
                    this.formGroup.controls['departureAirportId'].setValue(departureAirport.id);
                  }

                  let destinationAirport = this.ports.find((x) => {
                    return x.locode === destinationLocode
                  })

                  if(destinationAirport){
                    this.formGroup.controls['destinationAirportId'].setValue(destinationAirport.id);
                  }
                }
              }
          }

        });
        this.loading = false
        this.visible = false
    }

  validateField(value: any, field: string): boolean{
    if(isNaN(value)){
      this._messageService.add({
        severity: 'error',
        summary: this.translate.instant('MessageService.Excel.FailedAction'),
        detail: 'Error in ' + field + ' format'
      })
      return false;
    }else{
      return true
    }
  }

  loadDiscounts() {
    this.loading = true
    if(this.delivery) {
      this._deliveryDiscountService.getAllByDeliveryId(this.orderId).subscribe({
        next: (v) => {
          this.loading = false
          this.discounts.originDiscounts = this.getLocationTypeDiscounts(LocationType.Origen, v)
          this.discounts.destinationDiscounts = this.getLocationTypeDiscounts(LocationType.Destino, v)
        },
        error: (e) => {
          this.loading = false
          this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudieron recuperar los descuentos.' });
        },
        complete: () =>  {
          this.loading = false
          this.submitDiscount = false
        }
      })
    }
  }

  selectedDiscount: DeliveryDiscount | undefined
  openDiscountCreateDialog(data: {formDirective: FormGroupDirective, type: string}) {
    data.formDirective.resetForm()
    this.locationType = data.type;
    this.discountFormGroup.controls['description'].setValue('')
    this.discountFormGroup.controls['amount'].setValue(null)
    this.discountFormGroup.controls['currencyCode'].setValue('')
    if (data.type === LocationType.Origen) {
      this.discountFormGroup.controls['currencyCode'].setValue(this.currencies[0])
    }
    this.selectedDiscount = undefined
    this.submitDiscount = false
    this.discountDialogVisible = true
  }

  openDiscountEditDialog(data: {value: DeliveryDiscount, type: string}) {
    this.locationType = data.type;
    this.selectedDiscount = data.value
    this.discountFormGroup.controls['description'].setValue(this.selectedDiscount.description)
    this.discountFormGroup.controls['amount'].setValue(this.selectedDiscount.amount)
    this.discountFormGroup.controls['currencyCode'].setValue(this.selectedDiscount.currencyCode)
    this.discountDialogVisible = true
  }

  saveDiscount(){
    this.submitDiscount = true
    this.loading = true
    if(this.discountFormGroup.valid && this.delivery) {
      if(!this.selectedDiscount) {
        let discount: NewDeliveryDiscount = {
          description: this.discountFormGroup.controls['description'].value,
          amount: this.discountFormGroup.controls['amount'].value,
          currencyCode: this.discountFormGroup.controls['currencyCode'].value,
          locationType: this.locationType,
          importOrderId: this.orderId
        }

        this._deliveryDiscountService.create(discount).subscribe({
          next: (v) => {
            this.loadDiscounts()
            this.loading = false
            this.discountDialogVisible = false
            this._messageService.add({ severity: 'success', summary: 'Acción exitosa', detail: 'El descuento fue creado con éxito.' })
          },
          error: (e) => {
            this.loading = false
            this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudo crear el descuento.' });
          },
          complete: () =>  {
            this.loading = false
            this.submitDiscount = false
          }
        })
      }
      else {
        this.selectedDiscount.description = this.discountFormGroup.controls['description'].value
        this.selectedDiscount.amount = this.discountFormGroup.controls['amount'].value
        this.selectedDiscount.currencyCode = this.discountFormGroup.controls['currencyCode'].value
        this.selectedDiscount.locationType = this.locationType

        this._deliveryDiscountService.update(this.selectedDiscount).subscribe({
          next: (v) => {
            this.loadDiscounts()
            this.loading = false
            this.discountDialogVisible = false
            this._messageService.add({ severity: 'success', summary: 'Acción exitosa', detail: 'El descuento fue actualizado con éxito.' })
          },
          error: (e) => {
            this.loading = false
            this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudo actualizar el descuento.' });
          },
          complete: () =>  {
            this.loading = false
            this.submitDiscount = false
          }
        })
      }
    }
    else {
      this.loading = false
    }
  }

  deleteDiscount(id: number) {
    this.loading = true
    this._deliveryDiscountService.delete(id).subscribe({
      next: (v) => {
        this.loadDiscounts()
        this.loading = false
        this._messageService.add({ severity: 'success', summary: 'Acción exitosa', detail: 'El descuento fue eliminado con éxito.' })
      },
      error: (e) => {
        this.loading = false
        this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudo eliminar el descuento.' });
      },
      complete: () =>  {
        this.loading = false
        this.submitDiscount = false
      }
    })
  }

  get totalDiscounts(): number {
    let total = 0
    if(this.discounts) {
      this.discounts.originDiscounts.forEach(x => {
        total += x.amount
      })
    }
    return total
  }

  loadCosts() {
    this.loading = true
    if(this.delivery) {
      this._deliveryCostService.getAllByImportOrderId(this.orderId).subscribe({
        next: (v) => {
          this.loading = false
          this.costs.originCosts = this.getLocationTypeCosts(LocationType.Origen, v)
          this.costs.destinationCosts = this.getLocationTypeCosts(LocationType.Destino, v)
        },
        error: () => {
          this.loading = false
          this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudieron recuperar los costos.' });
        },
        complete: () =>  {
          this.loading = false
          this.submitDiscount = false
        }
      })
    }
  }

  openCostCreateDialog(data: {formDirective: FormGroupDirective, type: string}) {
    data.formDirective.resetForm()
    this.locationType = data.type;
    this.costFormGroup.controls['description'].setValue('')
    this.costFormGroup.controls['amount'].setValue(null)
    this.costFormGroup.controls['currencyCode'].setValue('')
    if (data.type === LocationType.Origen) {
      this.costFormGroup.controls['currencyCode'].setValue(this.currencies[0])
    }
    this.selectedCost = undefined
    this.submitCost = false
    this.costDialogVisible = true
  }

  openCostEditDialog(data: {value: DeliveryCost, type: string}) {
    this.locationType = data.type;
    this.selectedCost = data.value
    this.selectedCost.importOrderId = this.orderId
    this.costFormGroup.controls['description'].setValue(this.selectedCost.description)
    this.costFormGroup.controls['amount'].setValue(this.selectedCost.amount)
    this.costFormGroup.controls['currencyCode'].setValue(this.selectedCost.currencyCode)
    this.costDialogVisible = true
  }

  saveCost() {
    this.submitCost = true
    this.loading = true

    if (this.costFormGroup.valid && this.delivery) {
      let requestUrl = null;
      let request: any = {
        description: this.costFormGroup.controls['description'].value,
        amount: this.costFormGroup.controls['amount'].value,
        currencyCode: this.costFormGroup.controls['currencyCode'].value,
        locationType: this.locationType,
        importOrderId: this.orderId
      }

      // Configuración ruta cuando se crea un costo
      if (!this.selectedCost) {
        requestUrl = this._deliveryCostService.create(request);
      }
      // Configuración ruta cuando se actualiza un costo
      else {
        request = { ...this.selectedCost, ...request }
        requestUrl = this._deliveryCostService.update(request);
      }

      requestUrl.subscribe({
        next: () => {
          this.loadCosts()
          this.loading = false
          this.costDialogVisible = false
          this._messageService.add({ severity: 'success', summary: 'Acción exitosa', detail: 'El costo fue guardado con éxito.' })
        },
        error: () => {
          this.loading = false
          this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudo guardar el costo.' });
        },
        complete: () =>  {
          this.loading = false
          this.submitCost = false
        }
      })
    }
    else {
      this.loading = false
    }
  }

  deleteCost(id: number) {
    this.loading = true
    this._deliveryCostService.delete(id).subscribe({
      next: () => {
        this.loadCosts()
        this.loading = false
        this._messageService.add({ severity: 'success', summary: 'Acción exitosa', detail: 'El costo fue eliminado con éxito.' })
      },
      error: () => {
        this.loading = false
        this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudo eliminar el costo.' });
      },
      complete: () =>  {
        this.loading = false
        this.submitCost = false
      }
    })
  }

  // Sumatoria de costos estáticos (inputs independientes)
  get totalStaticCosts(): number {
    return this.formGroup.controls['oceanFreight'].value +
      this.formGroup.controls['inland'].value +
      this.formGroup.controls['localCharges'].value +
      this.formGroup.controls['customs'].value +
      this.formGroup.controls['otherCosts'].value +
      this.formGroup.controls['surcharge'].value +
      this.formGroup.controls['handling'].value +
      this.formGroup.controls['gateOut'].value +
      this.formGroup.controls['atmControl'].value +
      this.formGroup.controls['co2Reduction'].value +
      this.formGroup.controls['lowSulfurSurcharge'].value +
      this.formGroup.controls['advancedManifestDeclaration'].value +
      this.formGroup.controls['bunkerAdjustmentFactor'].value
  }

  // Sumatoria de costos estáticos y dinámicos
  get totalCosts(): number {
    const totalDynamicCosts = this.costs.originCosts.reduce((acc, curr) => {
      return acc + curr.amount;
    }, 0)

    return totalDynamicCosts + this.totalStaticCosts
  }

  onChangeFormMode()
  {
    console.log(this.IsfFormMode);
  }

  getCurrencies() {
    this._currencyService.getAll().subscribe({
      next: (v) => {
        this.currencies = v.map(x => x.currencyCode)
      }
    });
  }
}
